<template>
    <div class="row">
        <div class="col-md-6 mb-1">
            <label class="form-label">Ana Grup</label>
            <v-select-list v-model="mainGroup" label="Name" placeholder="Ana Grup" :options="mainGroups"/>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Alt Grup</label>
            <v-select-list :disabled="!mainGroup" v-model="subGroup" label="Name" placeholder="Alt Grup" :options="subGroups"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Araçlar</label>
            <v-select-list v-model="vehicle" multiple label="Vehicle" placeholder="Araçlar" :options="vehicles"/>
        </div>
        <div class="col-12 mb-1">
            <part-of-location :clearable="true" v-model="filter"></part-of-location> 
        </div>
        <div class="col-12">
            <div class="d-flex">
                <button class="btn btn-danger btn-sm w-20 mr-25" v-on:click="clearFilter">Temizle</button>
                <button class="btn btn-success btn-sm w-80 ml-25" v-on:click="setFilter">Filtrele</button>
            </div>
        </div>
    </div>
</template>

<script>
import PartOfLocation from './PartOfLocation.vue'
import MaintenanaceOperationsApi from '@/api/maintenance-operations'
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
export default {
    components:{
        PartOfLocation
    },
    data(){
        return{
            mainGroups:[],
            subGroups:[],
            vehicles:[],
            filter:{
                MainGroupOfMaintenanceInventoryId:null,
                SubGroupOfMaintenanceInventoryId:null,
                VehicleIds:[],
                LocationOfPart1:null,
                LocationOfPart2:null,
                LocationOfPart3:null,
                LocationOfPart4:null,
                LocationOfPart5:null,
                LocationOfPart6:null,
            }
        }
    },
    watch:{
        "filter.MainGroupOfMaintenanceInventoryId"(nevV,oldV){
            if(nevV != oldV){
                this.getSubGroups()
                this.filter.SubGroupOfMaintenanceInventoryId = null
            }
        }
    },
    mounted(){
        this.getMainGroups()
        this.getSubGroups()
        this.getVehicles()
    },
    methods:{
        clearFilter(){
            this.filter.MainGroupOfMaintenanceInventoryId = null
            this.filter.SubGroupOfMaintenanceInventoryId = null
            this.filter.VehicleIds = []
            this.filter.LocationOfPart1 = null
            this.filter.LocationOfPart2 = null
            this.filter.LocationOfPart3 = null
            this.filter.LocationOfPart4 = null
            this.filter.LocationOfPart5 = null
            this.filter.LocationOfPart6 = null
            this.$emit("filter",this.filter)
        },
        setFilter(){
            this.$emit("filter",this.filter)
        },
        getMainGroups(){
            MaintenanaceOperationsApi.MainGroup.List().then(res=>{
                this.mainGroups = res.data.Data
            })
        },
        getSubGroups(){
            if(this.filter.MainGroupOfMaintenanceInventoryId){
                MaintenanaceOperationsApi.SubGroup.List(this.filter.MainGroupOfMaintenanceInventoryId).then(res=>{
                    this.subGroups = res.data.Data
                })
            }
        },
        getVehicles(){
            VehicleDefinitionsApi.Vehicle.List().then(res=>{
                this.vehicles = res.data.Data
            })
        }
    },
    computed:{
        mainGroup:{
            get:function(){
                return this.mainGroups.find(m=>m.Id==this.filter.MainGroupOfMaintenanceInventoryId)
            },
            set:function(value){
                this.filter.MainGroupOfMaintenanceInventoryId = value?.Id || null
            }
        },
        subGroup:{
            get:function(){
                return this.subGroups.find(s=>s.Id==this.filter.SubGroupOfMaintenanceInventoryId)
            },
            set:function(value){
                this.filter.SubGroupOfMaintenanceInventoryId = value?.Id || null
            }
        },
        vehicle:{
            get:function(){
                return this.vehicles.filter(v=>this.filter.VehicleIds.includes(v.Id))
            },
            set:function(value){
                this.filter.VehicleIds = value?.map(v=>v.Id) || []
            }
        },
    }
}
</script>

<style>

</style>